import { api } from '@/utils/api'

import { ApiResponseHandler, Gettable } from './ApiInterfaces'
import { ApiBase, ResponseError } from './ApiBase'

export namespace ApiTaCt100 {
  // GET parameters
  export namespace Get {
    // API Request
    export interface Request {}

    // API Response
    export interface Response {
      cmsToken: string
    }
  }

  // API Path
  const path: string = '/ta/cmsTokens'

  // API本体
  export class Api extends ApiBase implements Gettable<Get.Request, Get.Response, ResponseError> {
    // GET
    public get<R>(
      params: Get.Request,
      successHandler: ApiResponseHandler<Get.Response, R>,
      errorHandler: ApiResponseHandler<ResponseError, R>
    ): Promise<R | null> {
      // 成功時のレスポンス構造サンプル
      const validationSample: Get.Response = {
        cmsToken: '',
      }
      // エラー時のレスポンス構造サンプル
      const validationErrorSample: ResponseError = {
        error: {
          messageId: '',
          message: '',
        },
      }

      // API呼び出し
      return this.callbackWrapper<Get.Response, ResponseError, R>(
        api.get<Get.Response>(path, params).then(response => {
          // 'akamaiToken'を'cmsToken'に変換
          // NOTE: API側のキーが変更されるまでの暫定対応
          if (response.data && 'akamaiToken' in response.data) {
            const data = response.data as { akamaiToken: string; [key: string]: any };
            data.cmsToken = data.akamaiToken as string;
            data.akamaiToken = '';
          }
          return response;
        }),
        successHandler,
        errorHandler,
        validationSample,
        validationErrorSample
      )
    }
  }
}
